import { useState } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { getMe, login, register } from '../services/api'
import AuthSplit from '../components/AuthSplit'

const fieldClass =
  'w-full h-10 px-3 rounded-lg border border-line bg-canvas text-ink text-sm outline-none focus:ring-2 focus:ring-accent'

export default function RegisterPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const redirectTo = (location.state as { redirectTo?: string } | null)?.redirectTo || '/dashboard'

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password !== confirmPassword) {
      setError('As senhas não coincidem')
      return
    }
    setLoading(true)
    try {
      await register(name, email, password)
      const data = await login(email, password)
      localStorage.setItem('token', data.access_token)
      if (data.refresh_token) localStorage.setItem('refreshToken', data.refresh_token)
      const user = await getMe()
      localStorage.setItem('user', JSON.stringify(user))
      navigate(redirectTo)
    } catch (err: unknown) {
      const detail = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail
      setError(detail || 'Erro ao criar conta')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthSplit>
      <h1 className="text-2xl font-semibold m-0">Criar conta</h1>
      <p className="text-sm text-muted mt-1.5 mb-6">Entre no time e comece uma sala.</p>

      {error && (
        <div className="mb-4 p-3 rounded-lg bg-bad/10 text-bad text-sm">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label htmlFor="register-name" className="block text-sm font-medium mb-1">Nome</label>
          <input id="register-name" type="text" value={name} onChange={(e) => setName(e.target.value)} required className={fieldClass} placeholder="Seu nome" />
        </div>
        <div>
          <label htmlFor="register-email" className="block text-sm font-medium mb-1">E-mail</label>
          <input id="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={fieldClass} placeholder="seu@email.com" />
        </div>
        <div>
          <label htmlFor="register-password" className="block text-sm font-medium mb-1">Senha</label>
          <input id="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} className={fieldClass} placeholder="Mínimo de 8 caracteres" />
        </div>
        <div>
          <label htmlFor="register-confirm-password" className="block text-sm font-medium mb-1">Confirmar senha</label>
          <input id="register-confirm-password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} className={fieldClass} />
        </div>
        <button type="submit" disabled={loading} className="h-10 rounded-lg bg-ink text-surface font-semibold cursor-pointer disabled:opacity-50">
          {loading ? 'Criando conta...' : 'Criar conta'}
        </button>
      </form>

      <p className="text-sm text-muted mt-6 m-0">
        Já tem uma conta?{' '}
        <Link to="/login" state={{ redirectTo }} className="text-accent font-medium">Entrar</Link>
      </p>
    </AuthSplit>
  )
}
